import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { sizeColumnsToFit } from '@client-shared/ui-agGrid';

import { notificationsPropType } from './propTypes';
import AgGrid from '../../shared/agGrid/agGrid.component';
import withPillNavigation from '../../shared/withPillNavigation.decorator';
import { pillsDefinition, pillsTypes } from './pillsDefinition';
import { columnDefs, fieldNames } from './columsDefinition';
import {
  alignCenterCellStyle,
} from '@common/cellStyles';
import routes from '../../routes';
import { decodeCountryTaxType } from '../../utils/encodeDecodeCTT';


const defaultColumnDefs = {
  ...alignCenterCellStyle,
};

class NotificationGrid extends PureComponent {
  static propTypes = {
    notifications: notificationsPropType,
    activePill: PropTypes.string.isRequired,
    notificationsLoading: PropTypes.bool.isRequired,
  };

  onGridReady = params => {
    sizeColumnsToFit(params.api);
  };

  onRowDataUpdated = params => {
    if (params.gridApi) {
      params.gridApi.applyColumnState({
        state: [
          { colId: 'companyCode', sort: 'asc' },
        ],
      });
      sizeColumnsToFit(params.gridApi);

      if (this.props.notifications.length) {
        const deselectOthers = true;
        params.gridApi.getModel().getRow(0).setSelected(true, deselectOthers);
      }
    }
  };

  render() {
    const { activePill, notifications, notificationsLoading } = this.props;

    const rowData = notifications && notifications[fieldNames[activePill]].map(row => {
      if (row.countryTaxType) {
        return {
          ...row,
          ...decodeCountryTaxType(row.countryTaxType),
        };
      }

      return row;
    });

    return (
      <div className="ag-grid-full-page-with-secondary-menu">
        <div className="row no-gutters">
          <div className="col">
            <div className="d-flex flex-row justify-content-between">
              <h5>Notifications</h5>
            </div>
          </div>
        </div>
        <AgGrid
          columnDefs={columnDefs[activePill]}
          defaultColDef={defaultColumnDefs}
          headerHeight={50}
          rowData={rowData}
          onGridReady={this.onGridReady}
          onRowDataUpdated={this.onRowDataUpdated}
          isGridLoading={notificationsLoading}
        />
      </div>
    );
  }
}

export default withRouter(withPillNavigation(
  () => pillsDefinition,
  {
    className: 'page-content-container',
    getActivePill: props => {
      switch (props.location.pathname) {
        case routes.balanceSheetManagement.notificationsSubRoutes.UNPOSTED_GL_JOURNALS:
          return pillsTypes.UNPOSTED_GL_JOURNALS;
        case routes.balanceSheetManagement.notificationsSubRoutes.DECLINED_TAX_ENTRIES:
          return pillsTypes.DECLINED_TAX_ENTRIES;
        case routes.balanceSheetManagement.notificationsSubRoutes.TAX_ENTRIES_PENDING_APPROVAL:
          return pillsTypes.TAX_ENTRIES_PENDING_APPROVAL;
        case routes.balanceSheetManagement.notificationsSubRoutes.APPROVED_TAX_ENTRIES:
          return pillsTypes.APPROVED_TAX_ENTRIES;
        default:
          return pillsDefinition[0].type;
      }
    },
  }
)(NotificationGrid));
